import { CurrencyLocation, CurrencyOptions, DecimalSeparator, RoundingMethod, ThousandsSeparator } from '@empathybroker/ebx-gluon';

export const MXN: CurrencyOptions = {
  currencyLocation: CurrencyLocation.PREPEND,
  currencySpacing: false,
  decimalDigits: 2,
  decimalSeparator: DecimalSeparator.COMMA,
  currencySymbol: '$',
  hideDecimalsIfZero: true,
  roundingMethod: RoundingMethod.ROUND,
  thousandsSeparator: ThousandsSeparator.NONE
};
